import { Directive, HostBinding} from '@angular/core';

@Directive({
    selector: '[appTheme]'
})
export class ThemeDirective
{
    // Theme strings must match the theme class names in /styles/brand.less
    // smrtScapetheme: string = "smrtScape";
    // fuglytheme: string = "fugly";

    @HostBinding('class.smrtScape') smrtScapeTheme = false;
    @HostBinding('class.fugly') fuglyTheme = false;

    constructor()
    {
        if (document.location.host === 'localhost:4201')
        {
            this.fuglyTheme = true;
            return;
        }
        this.smrtScapeTheme = true;
    }

}
